
import Hero from './components/Hero';
import Services from './components/Services';
import VideoShowcase from './components/VideoShowcase';
import Testimonials from './components/Testimonials';
import Booking from './components/Booking';
import Payment from './components/Payment';
import About from './components/About';
import Contact from './components/Contact';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <VideoShowcase />
      <Testimonials />
      <Booking />
      <Payment />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}
